<i class="icon"
   [ngClass]="{'material-icons': selected, 'material-icons-outlined': !selected}">
  <ng-content></ng-content>
</i>
